import { render, staticRenderFns } from "./SocialPostImageSlider.vue?vue&type=template&id=b4d480dc&"
import script from "./SocialPostImageSlider.vue?vue&type=script&lang=js&"
export * from "./SocialPostImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d480dc')) {
      api.createRecord('b4d480dc', component.options)
    } else {
      api.reload('b4d480dc', component.options)
    }
    module.hot.accept("./SocialPostImageSlider.vue?vue&type=template&id=b4d480dc&", function () {
      api.rerender('b4d480dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostImageSlider.vue"
export default component.exports